import React from "react";
import { Outlet } from "react-router-dom";
import { BottomNav } from "@/components/BottomNav";

export default function MemberLayout() {
  return (
    <div className="min-h-screen pb-24">
      <div className="max-w-xl mx-auto">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}
